import {StyleSheet} from "aphrodite";
import * as React from "react";

import {
    PhosphorIcon,
    type PhosphorIconAsset,
} from "@khanacademy/wonder-blocks-icon";
import {sizing} from "@khanacademy/wonder-blocks-tokens";

import type {
    ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions_BasicActivitySession_activityKind as BasicActivityKind,
    ActivitySessionsV2Query_user_activityLogV2_activitySessions_sessions_MasteryActivitySession_activityKind as MasteryActivityKind,
} from "./__graphql-types__/ActivitySessionsV2Query.ts";

import exerciseIcon from "@phosphor-icons/core/bold/pencil-simple-bold.svg";
import playIcon from "@phosphor-icons/core/bold/play-bold.svg";
import rocketLaunchIcon from "@phosphor-icons/core/bold/rocket-launch-bold.svg";
import sparkleIcon from "@phosphor-icons/core/fill/sparkle-fill.svg";
import articleIcon from "@phosphor-icons/core/regular/file.svg";

const getIconForActivityKind = (
    activityKind?: BasicActivityKind | MasteryActivityKind | null,
): PhosphorIconAsset => {
    switch (activityKind?.id) {
        case "Video":
            return playIcon;
        case "Exercise":
            return exerciseIcon;
        case "Article":
            return articleIcon;
        case "Project":
            return rocketLaunchIcon;
        default:
            return sparkleIcon;
    }
};

const ActivitySessionsContentIcon = ({
    activityKind,
}: {
    activityKind?: BasicActivityKind | MasteryActivityKind | null;
}): React.ReactElement => {
    return (
        <PhosphorIcon
            icon={getIconForActivityKind(activityKind)}
            size="small"
            style={styles.icon}
        />
    );
};

const styles = StyleSheet.create({
    icon: {
        marginInlineEnd: sizing.size_080,
    },
});

export default ActivitySessionsContentIcon;
